import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
// import { logger } from 'redux-logger';

import reducer from '../../reducers';
import rootSaga from '../../sagas';

import './app.css';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { COLOR_PRIMARY, COLOR_SECONDARY } from '../../utils/settings';

import Map from '../map/map';

const theme = createTheme({
  palette: {
    primary: {
      main: COLOR_PRIMARY,
      contrastText: '#ffffff'
    },
    secondary: {
      main: COLOR_SECONDARY,
    }
  },
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  reducer,
  applyMiddleware(sagaMiddleware),
);
sagaMiddleware.run(rootSaga);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <div className="App">
          <Map />
        </div>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
